import React, { useEffect, useState } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import "./DatabaseManagementDialog.scss";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function DatabaseManagementDialog() {
  const [backuping, setBackuping] = useState(false);
  const [restoring, setRestoring] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressText, setProgressText] = useState("");
  const [detailProgress, setDetailProgress] = useState(0);
  const [detailProgressText, setDetailProgressText] = useState("");
  const [show, setShow] = useState(false);
  const [backups, setBackups] = useState([]);
  const [confirmClosing, setConfirmClosing] = useState(false);
  const [confirmRestoring, setConfirmRestoring] = useState(false);
  const [restoreId, setRestoreId] = useState("");
  const [shuttingDown, setShuttingDown] = useState(false);

  const { t } = useTranslation();

  window.showDatabaseManagementDialog = () => {
    let str = window.cloudBridge.getBackups();
    let _backups = JSON.parse(str);
    setBackups(_backups);
    setShow(true);
  };

  //----------------
  // BACKUP
  //--------------

  window.backupEvent = (eventStr) => {
    let event = JSON.parse(eventStr);
    if (event.type === "DATABASE_FILE_SENT") {
      setProgressText(event.type);
      setProgress(event.progress);
    } else if (event.type === "SENDING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
    } else if (event.type === "ZIPPING_PROCESSED_CHUNK") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
      setDetailProgressText(event.chunk);
    } else if (event.type === "SENDING_PROCESSED_CHUNK") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
    } else if (event.type === "SPLITTING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
    } else if (event.type === "ZIPPING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
      setDetailProgressText(event.chunk);
    } else if (event.type === "SENDING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
      setDetailProgressText(event.chunk);
    } else if (event.type === "STOPPING_HUD") {
      setProgressText(event.type);
    } else if (event.type === "COUNTING_FILES") {
      setProgressText(event.type);
    } else if (event.type === "CREATING_BACKUP_FOLDER") {
      setProgressText(event.type);
    } else if (event.type === "SENDING_PROCESSED") {
      setProgressText(event.type);
    } else if (event.type === "ZIPPING_PROCESSED_CHUNK") {
      setProgressText(event.type);
      setDetailProgressText(event.text);
    } else if (event.type === "SENDING_PROCESSED_CHUNK") {
      setProgressText(event.type);
      setDetailProgressText(event.text);
    } else if (event.type === "ZIPPING_CONFIG") {
      setProgressText(event.type);
    } else if (event.type === "SENDING_CONFIG") {
      setProgressText(event.type);
    } else if (event.type === "SPLITTING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgressText(event.chunk);
    } else if (event.type === "ZIPPING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgressText(event.chunk);
    } else if (event.type === "SENDING_DATABASE_FILE") {
      setProgressText(event.type);
      setDetailProgressText(event.chunk);
    } else if (event.type === "DATABASE_FILE_SENT") {
      setProgressText(event.type);
      setDetailProgressText(event.chunk);
    } else if (event.type === "FINALYSING") {
      setDetailProgress(0);
      setProgressText(event.type);
      setDetailProgressText("");
    } else if (event.type === "FINALYSED") {
      setProgress(0);
      setProgressText("");
      setDetailProgress(0);
      setDetailProgressText("");
      setBackuping(false);
      window.showDatabaseManagementDialog();
    }
  };

  const cancelBackup = () => {
    setCanceling(true);
    window.cloudBridge.cancelBackup();
  };

  window.backupCancelDone = () => {
    setProgress(0);
    setProgressText("");
    setDetailProgress(0);
    setDetailProgressText("");
    setBackuping(false);
    setCanceling(false);
  };

  const backup = () => {
    setBackuping(true);
    window.cloudBridge.backup();
  };

  //--------------
  // RESTORE
  //--------------

  window.restoreEvent = (eventStr) => {
    //setBackuping(true);
    let event = JSON.parse(eventStr);
    console.log("restore event", event);
    if (event.type === "STOPPING_HUD") {
      setProgress(0);
      setProgressText(event.type);
    } else if (event.type === "DOWNLOADING_FILE") {
      setProgressText(event.type);
      setDetailProgress(event.progress);
      setDetailProgressText(event.chunk);
    } else if (event.type === "FILE_MANAGED") {
      setProgress(event.progress);
      setDetailProgress(0);
      setDetailProgressText("");
    } else if (event.type === "FINALYSING") {
      setCanceling(true);
      setDetailProgress(0);
      setProgressText(event.type);
      setDetailProgressText("");
    } else if (event.type === "FINALYSED") {
      setProgress(0);
      setProgressText("");
      setDetailProgress(0);
      setDetailProgressText("");
      setRestoring(false);
      setCanceling(false);
      setShuttingDown(true);
    }
  };

  const cancelRestore = () => {
    console.log("canceling restore");
    setCanceling(true);
    window.cloudBridge.cancelRestore();
  };

  window.restoreCancelDone = () => {
    setProgress(0);
    setProgressText("");
    setDetailProgress(0);
    setDetailProgressText("");
    setRestoring(false);
    setCanceling(false);
  };
  const restore = (_fileId) => {
    setRestoreId(_fileId);
    setConfirmRestoring(true);
  };
  const doRestore = () => {
    setRestoring(true);
    window.cloudBridge.restore(restoreId);
  };

  //----------
  // CLOSING
  //----------

  const closeAsked = () => {
    console.log("closing");
    if (backuping || restoring) {
      setConfirmClosing(true);
    } else {
      setShow(false);
    }
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  useEffect(() => {
    console.log("cloudBridge is ", window.cloudBridge);

    let timer = null;
    if (shuttingDown) {
      timer = setTimeout(() => {
        window.cloudBridge.shutdown();
      }, 3000);
    }

    return () => {
      console.debug("DatabaseManagementDialog effect done");
      if (shuttingDown) {
        clearTimeout(timer);
      }
    };
  }, [show, shuttingDown]);

  return (
    <>
      <Modal
        centered
        backdrop="static"
        show={confirmRestoring}
        dialogClassName="database-management-cancel-dialog"
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <Button
              onClick={() => {
                setConfirmRestoring(false);
              }}
            >
              X
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("app.backup.confirm_restore_message")}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setConfirmRestoring(false);
            }}
          >
            {t("app.backup.cancel_restore")}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setConfirmRestoring(false);
              doRestore();
            }}
          >
            {t("app.backup.restore")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        centered
        backdrop="static"
        show={confirmClosing}
        dialogClassName="database-management-cancel-dialog"
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <Button
              onClick={() => {
                setConfirmClosing(false);
              }}
            >
              X
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t(
            backuping
              ? "app.backup.cancel_backup_message"
              : "app.backup.cancel_restore_message"
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setConfirmClosing(false);
              backuping ? cancelBackup() : cancelRestore();
            }}
          >
            {t(
              backuping
                ? "app.backup.cancel_backup"
                : "app.backup.cancel_restore"
            )}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setConfirmClosing(false);
            }}
          >
            {t("app.backup.continue_backup")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        backdrop
        keyboard={false}
        animation={true}
        dialogClassName="database-management-dialog"
        onHide={() => setShow(false)}
      >
        <Modal.Header>
          <Modal.Title>
            <Button onClick={closeAsked} disabled={canceling}>
              X
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="database-management-panel d-flex flex-column align-items-center">
          {backuping || restoring ? (
            <div className="gauge">
              <Button
                className="cancel"
                onClick={backuping ? cancelBackup : cancelRestore}
                disabled={canceling}
              >
                {t("app.backup.cancel")}
              </Button>
              <CircularProgressbarWithChildren
                value={progress}
                maxValue={100}
                strokeWidth={8}
                styles={buildStyles({
                  textColor: "#d24b00",
                  pathColor: "#d24b00",
                  trailColor: "#333",
                  strokeLinecap: "butt"
                })}
                text={`${progress}%`}
              >
                <div style={{ width: "74%" }}>
                  <CircularProgressbar
                    value={detailProgress}
                    maxValue={100}
                    styles={buildStyles({
                      pathColor: "#3d9ed9",
                      trailColor: "#333",
                      strokeLinecap: "butt"
                    })}
                  />
                </div>
              </CircularProgressbarWithChildren>
              <div className="progress-text">
                &nbsp;{t("app.backup.event." + progressText)}&nbsp;
              </div>
              <div className="detail-progress-text">
                &nbsp;{detailProgressText}&nbsp;
              </div>
            </div>
          ) : (
            <>
              <div className="title">
                <div>{t("app.backup.title")}</div>
                <Button onClick={backup}>{t("app.backup.create")}</Button>
              </div>
              <Table
                className={
                  "backups " +
                  (backups.length === 0 || backuping || restoring ? "none" : "")
                }
                striped
                hover
              >
                <thead>
                  <tr>
                    <th>{t("app.backup.computer")}</th>
                    <th>{t("app.backup.date")}</th>
                    <th>{t("app.backup.size")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {backups.map((backup) => (
                    <tr key={backup.file.id}>
                      <td>{backup.name}</td>
                      <td>
                        {new Intl.DateTimeFormat(i18n.language, {
                          year: "numeric",
                          month: "short",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit"
                        }).format(backup.file.modifiedTime.value)}
                      </td>
                      <td>{formatBytes(backup.size, 2)}</td>
                      <td>
                        <Button onClick={() => restore(backup.file.id)}>
                          {t("app.backup.restore")}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>Progression</Modal.Footer>
      </Modal>
      <Modal
        centered
        backdrop="static"
        show={shuttingDown}
        dialogClassName="database-management-cancel-dialog"
        onHide={() => {}}
      >
        <Modal.Body>{t("app.backup.shutting_down")}...</Modal.Body>
      </Modal>
    </>
  );
}
export default DatabaseManagementDialog;
